import React from 'react'
import './Dashboard.css';
import plus_icon from "../../../Assets/icons/plus-Icons.svg";
import admin from "../../../Assets/admin.svg";
import teacher from "../../../Assets/teacher.svg";
import student from "../../../Assets/student.svg";


const Dashboard = () => {
  return (
    <div className='dashboard-wrap'>
        <div className='title'>
            <h1>Welcome to Dashboard</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
        </div>
        <div className='create-account'>
            <h2>Try to create account for your users</h2>
            <div className='cards'>
                <div className='create-card'>
                    <div className='text'>Create new admin</div>
                    <img className='card_img' src={admin} alt="admin" />
                </div>
                <div className='create-card'>
                    <div className='text'>Create new teacher</div>
                    <img className='card_img' src={teacher} alt="teacher" />
                </div>
                <div className='create-card'>
                    <div className='text'>Create new student</div>
                    <img className='card_img' src={student} alt="student" />
                </div>
            </div>
        
        </div>
        <div className='create-cources'>
            <h2>Help teachers, create new courses</h2>
            <div className='cource'>
                <h3>Create new course</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
                    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                    <button className='create'>
                        <img className ="btn_img" src={plus_icon} alt="plus" />
                        Create course now
                    </button>
            </div>
        </div>

    </div>
  )
}; 
export default Dashboard;
